export default __webpack_public_path__ + "code-fork-symbol.png";